import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FacetCollapseState,
  FacetService,
  ProductFacetService,
  ProductListComponentService,
} from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { ProductUtils } from '../../shared/utils/productUtils';
import { CustomProdPgService } from '../custom-prod-pg.service';

@Component({
    selector: 'app-custom-product-refinement',
    templateUrl: './custom-product-refinement.component.html',
    styleUrls: ['./custom-product-refinement.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomProductRefinementComponent implements OnInit, OnDestroy {
  [x: string]: any;
  public productList$ : any;
  public facetList$ : any;
  state$: Observable<FacetCollapseState> | undefined;
  facetList: any;
  facets: any;
  activefacets: any;
  userDetails: any;
  categoryList: any = [];
  categoryFormat: any = [];
  @ViewChild('facetsRwd', { static: false }) private readonly facetsRwd: any;
  selectedCategory: any;
  userDataSub: Subscription | undefined;
  facetListSub: Subscription | undefined;
  categorySub: Subscription | undefined;
  constructor(
    private readonly productListService: ProductListComponentService,
    private readonly test: ProductFacetService,
    private readonly facetService: FacetService,
    private readonly modalService: NgbModal,
    private readonly user: UserAccountFacade,
    private readonly customProdService: CustomProdPgService,
    private cdr: ChangeDetectorRef
  ) {
    this.productList$ = this.productListService.model$;
    this.facetList$ = this.test.facetList$;
  }

  ngOnInit(): void {
    this.userDataSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
      this.cdr.detectChanges();
    });

    let position: number;
    this.facetListSub = this.facetService.facetList$.subscribe((res) => {
      res.facets[0]?.values.forEach((resp, index) => {
        if (resp.name === 'Product Catalog') {
          position = index;
        }
      });
      const displayFacets = JSON.parse(JSON.stringify(res.facets));
      displayFacets[0]?.values.splice(position, 1);

      this.facets$ = displayFacets;

      this.activefacets = res?.activeFacets?.length;
      this.hide();
      this.cdr.detectChanges();
    });

    this.customProdService.getCategory();
    this.categorySub = this.customProdService.category$.subscribe((res) => {
      if (res) {
        this.categoryList = res;
        this.categoryFormat = ProductUtils.categoryFormatting(
          this.categoryList
        );
        this.selectedCategory = this.categoryFormat[0].value;
      }
      this.cdr.detectChanges();
    });
  }

  refine(): void {
    this.modalService.open(this.facetsRwd);
  }

  hide(): void {
    this.modalService.dismissAll(this.facetsRwd);
  }
  ngOnDestroy() {
    this.userDataSub?.unsubscribe();
    this.facetListSub?.unsubscribe();
    this.categorySub?.unsubscribe();
  }
}
